// extracted by mini-css-extract-plugin
export var blink = "_a5-2";
export var cursor = "_a5-1";
export var reactMarkdown = "_a5-3";
export var streamingText = "_a5-0";